import { useState } from 'react';

const range = (start, end) => (start === end ? [] : [start, ...range(start + 1, end)]);

const ITEMS_PER_PAGE = 50;
const PAGES_TO_DISPLAY = 5;

const usePaginatedList = (items, itemsPerPage = ITEMS_PER_PAGE, pagesToDisplay = PAGES_TO_DISPLAY) => {
  const [currentPage, setCurrentPage] = useState(1);

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  const totalPages = Math.ceil((items.length || 0) / itemsPerPage);

  const goToPage = (pageNumber) => () => setCurrentPage(pageNumber);
  const offset = Math.floor(pagesToDisplay / 2);
  const startPage = Math.max(1, currentPage - offset);
  const endPage = Math.min(startPage + pagesToDisplay - 1, totalPages);
  const visiblePages = range(startPage, endPage + 1);
  const isFirst = currentPage === 1;
  const isLast = currentPage === totalPages;

  return {
    items: items.slice(startIndex, endIndex),
    totalPages,
    currentPage,
    visiblePages,
    isFirst,
    isLast,
    goToPage,
    goToNextPage: goToPage(currentPage + 1),
    goToPreviousPage: goToPage(currentPage - 1),
  };
};

export default usePaginatedList;
